export const TEAM_COLORS = [
  '#007358',
  '#2E8BD8',
  '#C2803C',
  '#8E5BC8',
  '#D85A7A',
  '#2E9E8B',
  '#5B6CB8',
  '#B0553E',
] as const;

export type TeamColor = (typeof TEAM_COLORS)[number];

const HEX_COLOR_REGEX = /^#[0-9A-Fa-f]{6}$/;

export function isValidHexColor(value: string | undefined | null): boolean {
  return !!value && HEX_COLOR_REGEX.test(value);
}

export function getDefaultTeamColor(seed: string): TeamColor {
  let hash = 0;
  for (let i = 0; i < seed.length; i += 1) {
    hash = (hash * 31 + seed.charCodeAt(i)) >>> 0;
  }
  return TEAM_COLORS[hash % TEAM_COLORS.length];
}
